<div class="preview" (click)="preview()">
  <img [ngSrc]="currentImage|fileurl" fill [alt]="altText" />
</div>
<swiper-container slides-per-view="auto" space-between="20" #swiper (swiperslidechange)="index=swiper.swiper.realIndex">
  @for (image of images; track $index) {
  <swiper-slide lazy="false" [ngClass]="{active:index===$index}">
    <img [ngSrc]="image|fileurl" fill (click)="choose($index)" [alt]="altText + ' image ' + ($index + 1)" />
  </swiper-slide>
  }
</swiper-container>
